
export default function inlineWorker(scriptText) {
  let base64 = btoa(scriptText);
  let url = new URL(`data:application/javascript;base64,${base64}`);
  let worker = new Worker(url);
  return worker;
}
